import { createContext, useState } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.id === product.id);

      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      const withDefaults = {
        ...product,
        quantity: product.quantity || 1,
      };

      // Defaults for products that require check-in date/time selection
      if (withDefaults.checkinDT) {
        const categoryKey = withDefaults.categoryId || withDefaults.category || 'General';
        const existingInCategory = prev.find(
          (i) => (i.categoryId || i.category || 'General') === categoryKey && !!i.checkinDT
        );

        // Share the same schedule UI per tab/category by copying any existing schedule
        // from that category into the newly-added item.
        withDefaults.scheduleMode = existingInCategory?.scheduleMode || withDefaults.scheduleMode || 'week';
        withDefaults.scheduleCountMode =
          existingInCategory?.scheduleCountMode || withDefaults.scheduleCountMode || 'single';
        withDefaults.dateDels = Array.isArray(existingInCategory?.dateDels)
          ? existingInCategory.dateDels
          : Array.isArray(withDefaults.dateDels)
            ? withDefaults.dateDels
            : [];
        withDefaults.dateDel = withDefaults.dateDel || (withDefaults.dateDels[0] || '');
        withDefaults.timeDel = existingInCategory?.timeDel || withDefaults.timeDel || '';
      }

      return [...prev, withDefaults];
    });
  };

  const updateCartItem = (id, updates) => {
    setCartItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, ...updates } : item))
    );
  };

  const increaseQuantity = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decreaseQuantity = (id) => {
    setCartItems((prev) =>
      prev
        .map((item) =>
          item.id === id
            ? { ...item, quantity: Math.max(item.quantity - 1, 1) }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const cartTotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        updateCartItem,
        increaseQuantity,
        decreaseQuantity,
        removeFromCart,
        clearCart,
        cartTotal,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
